import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import BaseModal from '../common/base-modal'
import ModalHeader from '../common/base-modal/ModalHeader'

import FoodItemMobile from './FoodItemMobile'

const ListFood = ({
    id,
    group = {},
    list = [],
    setFoodSelected,
    handleFastAddToCart,
    handleUpdateAmount,
    handleViewFoodInCart,
    setFoodEditNote,
    groupRef,
}) => {
    const [moreInfo, setMoreInfo] = useState('')
    const { t } = useTranslation()

    return (
        <div
            id={id}
            group-data={group.id}
            className="list-food flex-1 container-fluid container-xl"
            ref={groupRef}
        >
            <BaseModal
                isOpen={!!moreInfo}
                contentClassName="food-info-more"
                onRequestClose={() => setMoreInfo('')}
            >
                <ModalHeader onClose={() => setMoreInfo('')}>{t('modalMoreInfo.title')}</ModalHeader>
                <div
                    className="content paragraph-2 mt-4"
                    dangerouslySetInnerHTML={{ __html: moreInfo }}
                />
            </BaseModal>

            <div className="list-food__info-group">
                <div className="list-food__info-group--name">
                    {group.name || '-'}
                </div>

                {group.description && (
                    <div className="list-food__info-group--description mt-1">
                        {group.description}
                    </div>
                )}
            </div>

            <div className="row mt-4 list">
                {list.map((item, index) => (
                    <div key={index} className="col-12">
                        <FoodItemMobile
                            handleUpdateAmount={handleUpdateAmount}
                            handleViewFoodInCart={handleViewFoodInCart}
                            setFoodSelected={setFoodSelected}
                            item={item}
                            handleFastAddToCart={handleFastAddToCart}
                            setFoodEditNote={setFoodEditNote}
                            setMoreInfo={setMoreInfo}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ListFood
